module.exports = __webpack_public_path__ + "img/D201511_2.45a7a2e6.jpg";